export default __webpack_public_path__ + "static/media/element_67.ea86c04d.jpg";